import { render, staticRenderFns } from "./ExtrasShipment.vue?vue&type=template&id=9ff8b1a4&scoped=true"
import script from "./ExtrasShipment.vue?vue&type=script&lang=ts"
export * from "./ExtrasShipment.vue?vue&type=script&lang=ts"
import style0 from "./ExtrasShipment.vue?vue&type=style&index=0&id=9ff8b1a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff8b1a4",
  null
  
)

export default component.exports